import InputInfo from './InputInfo'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { Button, Col, Form, InputNumber, Row, Select, Typography } from 'antd'
import AutoSearch from '../AutoSearch'
import { InfoModal } from '../common'
import Enumeration from './Enumeration'
import TextInfo from './TextInfo'
import LanguageList from './LanguageList'

const { Paragraph, Text } = Typography

const DetailsForm = ({ children }) => {
  const { t } = useTranslation()
  return (
    <>
      <br />
      <br />
      <Row justify={'space-between'} gutter={{ sm: 0, xl: 90 }}>
        <Col xs={24} sm={14} xl={12}>
          <InputInfo
            name="title"
            required={true}
            requiredMessage={t('Details.error.PleaseEnterTitle')}
            label={t('Details.Title')}
            info={t('Details.Title.info')}
          />
          <InputInfo
            name="subtitle"
            label={t('Details.Subtitle')}
            info={t('Details.Subtitle.info')}
            placeholder={t('Details.Subtitle.placeholder')}
          />
          <br />
          <Form.Item label={t('Details.Category')}>
            <Enumeration
              name="categories"
              inputName="categories"
              placeholder={t('Details.Category.placeholder')}
            />
            <span className="input-info">
              <InfoModal>{t('Details.Category.info')}</InfoModal>
            </span>
          </Form.Item>
          <AutoSearch
            label={t('Details.Subject')}
            info={t('Details.Subject.info')}
            name="subject"
            placeholder={t('Details.Subject.placeholder')}
          />
          <InputInfo
            name="grade"
            label={t('Details.Grade')}
            info={t('Details.Grade.info')}
            placeholder={t('Details.Grade.placeholder')}
          />
          <Form.Item label={t('Details.Year')}>
            <Form.Item name="copyright_year" noStyle>
              <InputNumber
                stringMode={true}
                style={{ width: 220 }}
                min={1}
                placeholder={t('Details.Year.placeholder')}
              />
            </Form.Item>
          </Form.Item>
          <br />
          <AutoSearch
            name="institutions"
            scope="institution"
            label={t('Details.University')}
            placeholder={t('Details.University.placeholder')}
            info={t('Details.University.info')}
            addNonExistant={true}
            newItemName="institutions_name"
            newItemLabel={t('Details.NewUniversity.Individual')}
            newItemButtonLabel={t('Details.NewUniversity.CantFind')}
            newItemPlaceholder={t('Details.NewUniversity.Enter')}
          />

          <InputInfo
            name="institute"
            label={t('Details.Institute')}
            info={t('Details.Institute.info')}
            placeholder={t('Details.Institute.placeholder')}
          />
          <InputInfo
            name="course"
            label={t('Details.Course')}
            info={t('Details.Course.info')}
            placeholder={t('Details.Course.placeholder')}
          />
          <Form.Item label={t('Details.Language')}>
            <LanguageList
              name="languages"
              inputName="language"
              placeholder={t('Details.Language.placeholder')}
            />
            <span className="input-info">
              <InfoModal>{t('Details.Language.info')}</InfoModal>
            </span>
          </Form.Item>
          <br />
          <br />
          <Form.Item label={t('Details.Keywords')} className="keywords">
            <Form.Item name="keywords" noStyle>
              <Select
                mode="tags"
                placeholder={t('Details.Keywords.placeholder')}
              />
            </Form.Item>
            <span className="input-info">
              <InfoModal>{t('Details.Keywords.info')}</InfoModal>
            </span>
          </Form.Item>
        </Col>
        <Col sm={8} xl={10} className="show-on-desktop">
          {children}
        </Col>
        <Col lx={24} xs={24}>
          <br />
          <br />
          <Paragraph className="paragraph-sb">
            {t('Details.Abstract')}
          </Paragraph>
          <Text className="caption">{t('Details.AbstractDescription1')}</Text>
          <br />
          <Text className="caption-sb">
            {t('Details.AbstractDescription2')}
          </Text>
          <TextInfo
            name="abstract"
            description={t('Details.AbstractCharacters')}
            info={t('Details.Abstract.info')}
            placeholder={t('Details.Abstract.placeholder')}
            max={2500}
          />
          <br />
          <Paragraph className="paragraph-sb">{t('Details.Remarks')}</Paragraph>
          <Text className="caption">{t('Details.RemarksDescription1')}</Text>
          <br />
          <Text className="caption-sb">{t('Details.RemarksDescription2')}</Text>
          <TextInfo
            name="bibliographic_remark"
            description={t('Details.RemarksCharacters')}
            info={t('Details.Remarks.info')}
            placeholder={t('Details.Remarks.placeholder')}
            max={2500}
          />
        </Col>
      </Row>
      <Button type="primary" htmlType="submit">
        {t('Details.Save.button')}
      </Button>
    </>
  )
}

export default DetailsForm
